import * as apiAccess from './api-access';
import Config from './developer-settings.router';
import options from './developer-settings.component';

const Component = {
    selector: 'dtDeveloperSettings',
    options
};

export {
    apiAccess,
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/developer-settings/index.js